import type { DialogContentNode } from "@/v2/framework/dialog/types";
import { getSupplementalsByEntity } from "@/services/supplementals";

type MarketGroupTranslationRow = {
  name?: string | null;
  info?: string | null;
  supplementalNames?: { supplementalNameTypeId: string; name?: string | null }[];
};

export const buildMarketGroupTranslationFields = () => {
  const nodes: DialogContentNode[] = [
    {
      type: "text-field",
      name: "name",
      label: "table_columns.name",
      placeholder: "Enter name",
    },
    {
      type: "text-field",
      name: "info",
      label: "table_columns.info",
      placeholder: "Enter info",
    },
  ];

  for (const supplementalNameType of getSupplementalsByEntity("MARKET_GROUP")) {
    nodes.push({
      type: "text-field",
      name: `supplementalName_${supplementalNameType.id}`,
      label: `table_columns.${supplementalNameType.name.toLowerCase()}`,
      placeholder: "Enter name",
      valueFormatter: (row: unknown) => {
        const item = row as MarketGroupTranslationRow;
        return (
          item.supplementalNames?.find(
            (entry) => String(entry.supplementalNameTypeId) === String(supplementalNameType.id),
          )?.name ?? ""
        );
      },
    });
  }

  return nodes;
};
